import React from 'react';
import ReactDOM from 'react-dom';
import * as styles from './loader.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var LOADER_SIZE;

(function (LOADER_SIZE) {
  LOADER_SIZE["COMPACT"] = "compact";
  LOADER_SIZE["LARGE"] = "large";
  LOADER_SIZE["MINI"] = "mini";
})(LOADER_SIZE || (LOADER_SIZE = {}));

var Portal = function Portal(_ref) {
  var children = _ref.children;
  return typeof document === 'undefined' ? children : /*#__PURE__*/ReactDOM.createPortal(children, document.querySelector('body'));
};

var Loader = function Loader(_ref2) {
  var _ref2$dark = _ref2.dark,
      dark = _ref2$dark === void 0 ? false : _ref2$dark,
      icon = _ref2.icon,
      _ref2$transparent = _ref2.transparent,
      transparent = _ref2$transparent === void 0 ? false : _ref2$transparent,
      _ref2$done = _ref2.done,
      done = _ref2$done === void 0 ? false : _ref2$done,
      _ref2$error = _ref2.error,
      error = _ref2$error === void 0 ? false : _ref2$error,
      className = _ref2.className,
      message = _ref2.message,
      size = _ref2.size,
      _ref2$fullscreen = _ref2.fullscreen,
      fullscreen = _ref2$fullscreen === void 0 ? false : _ref2$fullscreen;
  var configuration = {
    'is-dark': dark,
    'is-transparent': transparent,
    'is-done': done,
    'is-error': error,
    'is-fullscreen': fullscreen
  };

  if (size) {
    configuration["is-".concat(size)] = !!size;
  }

  var Wrapper = fullscreen ? Portal : React.Fragment;
  return ___EmotionJSX(Wrapper, null, ___EmotionJSX("span", {
    className: className,
    "data-testid": "loader",
    css: styles.loader(configuration)
  }, ___EmotionJSX("span", {
    "data-testid": "container",
    css: styles.container
  }, ___EmotionJSX("span", {
    "data-testid": "spinner",
    css: styles.spinner(configuration)
  }), icon), message && ___EmotionJSX("div", {
    "data-testid": "message",
    css: styles.message(configuration)
  }, message)));
};

Loader.defaultProps = {
  dark: false,
  transparent: false,
  done: false,
  error: false,
  className: undefined,
  message: undefined,
  icon: undefined,
  size: undefined,
  fullscreen: false
};
export default Loader;
export { Portal, LOADER_SIZE };